import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  background: #f5f7f8;
  position: absolute;
  top: 135px;
  left: 230px;
  bottom: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px;
  width: auto;
`;

export const Card = styled.div`
  padding-top: 20px!important;
  border-radius: 4px;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0 8px 16px 0 #00376d1a;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  border: none;
  margin: 5px;
  padding: 0;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  
  &:hover {
    opacity: 1;
  }
  
  &:focus {
    outline: 1px solid #764ab0 !important;
  }
  
  svg {
    pointer-events: none;
  }
`;

export const ModalContentContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  padding-bottom: 10px;
`;